import React, {useEffect, useState} from 'react';
import {TableCell} from "@mui/material";
import localStrings from "../../../localStrings";
import useAuth from "../../../hooks/useAuth";
import useAppUtil from "../../../hooks/useAppUtil";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import ClipLoaderComponent from "../../../components/ClipLoaderComponent";
import GeneralResult from "../../../components/CrudFrom/GeneralResult";
import {
  bulkDeleteEstablishmentMutation,
  deleteEstablishmentCache,
  getAllEstablishmentsQuery
} from "../../../gql/establishmentGql";
import {
  bulkDeleteChartImplementationMutation,
  deleteChartImplementationFromCache,
  getChartImplementationsQuery
} from "../../../gql/chartImplementationGql";
import {getChartImplementation} from "../ChartImplementationAddView/ChartImplementationCreateUpdateForm";

const Results = ({className, ...rest}) => {
  const {
    currentBrand,
    currentEstablishment
  } = useAuth();
  const { addWarning, addError} = useAppUtil();
  const [itemSource, setItemSource] = useState(null);

  useEffect(() => {
    async function setItemSourceAsync() {
      let result = await getChartImplementations();
      setItemSource(result);
    }
    setItemSourceAsync();
  }, []);


  const getChartImplementations = async () => {
    return await executeQueryUtil(getChartImplementationsQuery());
  }

  const getTableCellColumn = () => {
    return(
      <React.Fragment>
        <TableCell>
          {localStrings.name}
        </TableCell>
      </React.Fragment>
    )
  }

  const getTableCell = (item) => {
    return(
      <React.Fragment>
        <TableCell>
          {item.name}
        </TableCell>
      </React.Fragment>
    )
  }

  const deleteItems = async (ids) => {
    await executeMutationUtil(bulkDeleteChartImplementationMutation(ids));
    await deleteChartImplementationFromCache(ids);
    let itemUpdate = await getChartImplementations();
    setItemSource(itemUpdate)
    return true;
  }


  const sortOptions = [
    {
      value: 'name|asc',
      label: localStrings.name
    },
  ];

  return (
    <>
      { itemSource ?
        <GeneralResult
          className={className}
          getPathToData={(result) => result.data.getChartImplementations}
          getTableCell={getTableCell}
          getTableCellColumn={getTableCellColumn}
          getEditLink={(item) => "/dashboard/chartImplementations/detail/" + item.id}
          deleteDialogText={localStrings.confirmMessage.deleteItem}
          deleteItemsFunction={deleteItems}
          deleteItemNotifMessage={localStrings.notif.chartImplementationDeleted}
          sortOptions={sortOptions}
          searchProperties={['name']}
          itemsSource={itemSource}
        >
        </GeneralResult>
        :
        <ClipLoaderComponent/>
      }
    </>
  )

};


export default Results;
